import { render, staticRenderFns } from "./BonsLivraisonApproView.vue?vue&type=template&id=101be32d"
import script from "./BonsLivraisonApproView.vue?vue&type=script&lang=js"
export * from "./BonsLivraisonApproView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports